import parseUrl from 'url-parse';
import { ApiReadyWebsiteConfiguration, WebsiteConfiguration } from '../types/websiteConfiguration';

export const prepareForRender = (config: WebsiteConfiguration) => {
  const { footer_custom_links, ...rest } = config;

  return {
    ...rest,
    ...(footer_custom_links &&
      footer_custom_links.length > 0 && {
        footer_custom_links: footer_custom_links.map((item, index) => ({ ...item, id: String(index) })),
      }),
  };
};

export const prepareForValidation = (config: WebsiteConfiguration) => {
  const { footer_custom_links, banners, ...rest } = config;

  return {
    ...rest,
    ...(footer_custom_links && footer_custom_links.length > 0 && { footer_custom_links }),
  };
};

export const prepareForApi = (config: WebsiteConfiguration): ApiReadyWebsiteConfiguration => {
  const { footer_custom_links, banners, hero, ...rest } = config;

  return {
    ...rest,
    ...(hero && {
      hero: {
        ...hero,
        ...(hero.images && hero.images.length > 0 ? { images: hero.images.map((item) => item || null) } : {}),
      },
    }),
    ...(footer_custom_links &&
      footer_custom_links.length > 0 && { footer_custom_links: footer_custom_links.map(({ id, ...rest }) => rest) }),
    ...(banners?.length && { banners }),
  };
};

export const removeEmptyFields = <T>(obj: Partial<T>): Partial<T> => {
  const finalObj: Partial<T> = {};
  Object.keys(obj).forEach((key) => {
    if (obj[key] && typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
      const nestedObj = removeEmptyFields(obj[key]);
      if (Object.keys(nestedObj).length) {
        finalObj[key] = nestedObj;
      }
    } else if (Array.isArray(obj[key])) {
      if (obj[key].length) {
        obj[key].forEach((x) => {
          if (typeof x !== 'object' || x === null) {
            finalObj[key] = finalObj[key] ? [...finalObj[key], x] : [x];
          } else {
            const nestedObj = removeEmptyFields(x);
            if (Object.keys(nestedObj).length) {
              finalObj[key] = finalObj[key] ? [...finalObj[key], nestedObj] : [nestedObj];
            }
          }
        });
      }
    } else if (obj[key] !== '' && obj[key] !== undefined && obj[key] !== null) {
      finalObj[key] = obj[key];
    }
  });

  return finalObj;
};

export const formatUrl = (inputURL: string) => {
  const url = parseUrl(inputURL, inputURL);

  if (!url.protocol) {
    url.set('protocol', 'https');
  }

  const parsedUrl = url.toString();
  const urlWithoutTrailingSlash = parsedUrl.endsWith('/') ? parsedUrl.slice(0, -1) : parsedUrl;

  return urlWithoutTrailingSlash;
};
